import { render, staticRenderFns } from "./PosTableDetailALaCarte.vue?vue&type=template&id=5e454dce&scoped=true"
import script from "./PosTableDetailALaCarte.vue?vue&type=script&lang=js"
export * from "./PosTableDetailALaCarte.vue?vue&type=script&lang=js"
import style0 from "./PosTableDetailALaCarte.vue?vue&type=style&index=0&id=5e454dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e454dce",
  null
  
)

export default component.exports